module.exports = __webpack_public_path__ + "static/media/ResponPic9.098b0158.jpg";